import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LoadingScreen.css';

const LoadingScreen = () => {
  const { t } = useTranslation('common');
  return (
    <div className="loading-outer" role="status">
      <div className="spinner-wrapper">
        <img src="/images/loading.svg" alt={t('loading')} className="loading" />
      </div>
    </div>
  );
};

export default LoadingScreen;
